module.exports = __webpack_public_path__ + "img/notification-error.641364d7.svg";